module.exports = __webpack_public_path__ + "static/media/Fast_Effect_Chloroform.36b1644f.mp3";